import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { coupleTestimonials } from '@/mocks/wedding'

export default function WeddingTestimonialsSection() {
  const { t } = useTranslation()

  return (
    <section id="wedding-reviews" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('wedding.reviews.label')}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('wedding.reviews.title')}
            </h2>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed">{t('wedding.reviews.intro')}</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 text-primary-500">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill text-lg" />
              ))}
            </div>
            <span className="text-sm text-foreground-600">{t('wedding.reviews.rating')}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {coupleTestimonials.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-100 overflow-hidden flex flex-col"
            >
              <div className="w-full h-52 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${t(`wedding.reviews.items.${item.id}.name`)} — wedding photographed by Shabi Media`}
                  title={`${t(`wedding.reviews.items.${item.id}.name`)} | Shabi Media wedding photography`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center justify-between mb-4">
                  <i className="ri-double-quotes-l text-primary-400 text-3xl" />
                  <div className="flex items-center gap-1 text-primary-500">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                </div>
                <p className="font-heading italic text-base md:text-lg text-foreground-800 leading-relaxed flex-1">
                  {t(`wedding.reviews.items.${item.id}.quote`)}
                </p>
                <div className="mt-6 pt-5 border-t border-background-200 flex items-center gap-3">
                  <span className="w-11 h-11 rounded-full flex items-center justify-center bg-accent-100 text-accent-700 font-heading text-lg font-semibold">
                    {t(`wedding.reviews.items.${item.id}.name`).charAt(0)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">
                      {t(`wedding.reviews.items.${item.id}.name`)}
                    </span>
                    <span className="block text-xs text-foreground-500 mt-0.5">
                      {t(`wedding.reviews.items.${item.id}.wedding`)}
                    </span>
                  </span>
                </div>
                {item.id === 'ct1' && (
                  <Link
                    to="/wedding-stories/aarthi-karthik"
                    className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 cursor-pointer hover:text-primary-600 transition-colors"
                  >
                    {t('wedding.reviews.readStory')}
                    <i className="ri-arrow-right-line text-base" />
                  </Link>
                )}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/wedding-stories"
            className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-book-open-line text-lg" />
            {t('weddingStories.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  )
}